const initState = {
  show: false,
  title: "",
  content: "",
  buttonGroup: <></>,
};

const notificationReducer = (state = initState, action) => {
  if (action.type === "UPDATE_NOTIFICATION_SHOW") {
    return {
      ...state,
      show: action.payload,
    };
  } else if (action.type === "UPDATE_NOTIFICATION_TITLE") {
    return {
      ...state,
      title: action.payload,
    };
  } else if (action.type === "UPDATE_NOTIFICATION_CONTENT") {
    return {
      ...state,
      content: action.payload,
    };
  } else if (action.type === "UPDATE_NOTIFICATION_BUTTON_GROUP") {
    return {
      ...state,
      buttonGroup: action.payload,
    };
  }

  return state;
};

export default notificationReducer;
